<div class="settings-section-wrapper">
  <app-notification-settings></app-notification-settings>
</div>

<div class="notifications-section">
  <div class="section-header">
    <h3 class="section-title">{{ 'Notifications' | translate }}</h3>
    <button
      mat-button
      [disabled]="!hasUnread"
      color="primary"
      (click)="markAllAsRead()"
      class="mark-read-btn"
    >
      {{ 'Mark all as read' | translate }}
    </button>
  </div>

  @if (loading) {
    <div class="loading-state">
      <mat-icon class="spin">sync</mat-icon>
    </div>
  } @else if (notifications.length > 0) {
    <div class="notif-list">
      @for (notif of notifications; track notif.id) {
        <div
          class="notif-item-wrapper"
          [class.read]="notif.read"
          [ngClass]="'sev-' + notif.severity"
        >
          <div class="notif-main" (click)="markAsRead(notif)">
            <span
              class="sev-chip"
              role="img"
              [attr.aria-label]="'severity_' + notif.severity | translate"
            >
              <mat-icon aria-hidden="true">{{ severityIcons[notif.severity] }}</mat-icon>
            </span>
            <div class="notif-content">
              <div class="notif-title">
                @if (!notif.read) {
                  <span class="sr-only">{{ 'Unread' | translate }}</span>
                }
                {{ notif.title | translate }}
              </div>
              <div class="notif-body-text">{{ translationService.translateBody(notif) }}</div>
              <div class="notif-date">{{ notif.created_at | date: 'short' }}</div>
            </div>
          </div>
        </div>
      }
    </div>

    @if (totalPages > 1) {
      <div class="pagination-controls">
        <button
          class="pagination-btn"
          [disabled]="currentPage === 1"
          (click)="prevPage()"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="pagination-info">{{ currentPage }} / {{ totalPages }}</span>
        <button
          class="pagination-btn"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    }
  } @else {
    <div class="empty-notif-state">
      <i class="pi pi-bell"></i>
      <p>{{ 'No notifications yet' | translate }}</p>
    </div>
  }
</div>

@if (isAdmin) {
  <div class="admin-section">
    <h3 class="section-title">
      {{ 'Send Notification to Club Members' | translate }}
    </h3>

    <form
      (ngSubmit)="createNotificationByAdmin()"
      #notifForm="ngForm"
      class="minimal-form"
    >
      <div class="form-field-group">
        <label>{{ 'Title' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput name="title" [(ngModel)]="title" required placeholder="Enter title" />
        </mat-form-field>
      </div>

      <div class="form-field-group">
        <label>{{ 'Message' | translate }}</label>
        <mat-form-field appearance="outline">
          <textarea
            matInput
            name="message"
            [(ngModel)]="message"
            required
            rows="4"
            placeholder="Write your message here..."
          ></textarea>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="submit-btn"
          [disabled]="notifForm.invalid"
        >
          {{ 'Send' | translate }}
        </button>
      </div>
    </form>
  </div>
}

@if (isAdmin) {
  <div class="admin-section announcement-section">
    <h3 class="section-title">
      {{ 'Post an announcement' | translate }}
    </h3>

    <form
      (ngSubmit)="createAnnouncement()"
      #announcementForm="ngForm"
      class="minimal-form"
    >
      <div class="form-field-group">
        <label>{{ 'Title' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            name="title"
            maxlength="64"
            [(ngModel)]="announcement_title"
            required
            placeholder="Announcement Title"
          />
        </mat-form-field>
      </div>

      <div class="form-field-group">
        <label>{{ 'Message' | translate }}</label>
        <mat-form-field appearance="outline">
          <textarea
            matInput
            name="message"
            [(ngModel)]="announcement_body"
            required
            rows="4"
            maxlength="512"
            placeholder="Announcement Body"
          ></textarea>
          <mat-hint align="end">{{ announcement_body.length }} / 512</mat-hint>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="submit-btn"
          [disabled]="announcementForm.invalid"
        >
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
}
